import { createFeature } from '@ngrx/store';
import { headerNotificationsReducer } from './header-notifications-reducer';

export const headerNotificationsFeature = createFeature({
  name: 'headerNotifications',
  reducer: headerNotificationsReducer
});
